function Footer() {
  return (
    <footer className="footer">
      <a href="https://tomiwa-portfolio.netlify.app">Tomiwa</a> ©2023
    </footer>
  );
}

export default Footer;
